import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    loadTotal: -1,
    loadList: -1,
  },
  total: 0,
  list: [],
  pagination: {},
  error: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case ACTION_TYPES.PRESCRIPTION_TOTAL_GET_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadTotal: 0,
        },
      };
    case ACTION_TYPES.PRESCRIPTION_TOTAL_GET_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          loadTotal: 1,
        },
        total: payload.data.total,
      };
    case ACTION_TYPES.PRESCRIPTION_TOTAL_GET_FAILED:
      return {
        ...state,
        status: {
          loadTotal: 2,
        },
        error,
      };

    case ACTION_TYPES.PRESCRIPTIONS_GET_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadList: 0,
        },
      };
    case ACTION_TYPES.PRESCRIPTIONS_GET_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          loadList: 1,
        },
        list: payload.data,
        pagination: payload.meta.pagination,
      };
    default:
      return state;
  }
}
